// El producto REAL del crédito. `creditos.producto` guarda el nombre que viene de la
// solicitud / catálogo de productos (`requisitos.py:1331`). Los créditos viejos no lo traen:
// para esos se usa la etiqueta del instrumento (`tipo_credito`), con las mismas palabras que
// `REQUISITOS_DEFAULT[...].tipo_label` del backend. Una sola función para TODAS las pantallas:
// así el Perfil 360 no puede decir un producto arriba y otro abajo.
const ETIQUETA_INSTRUMENTO = {
  SIMPLE: "Simple / Personal",
  NOMINA: "Nómina",
  AUTOMOTRIZ: "Automotriz",
  HIPOTECARIO: "Hipotecario",
  PRENDARIO: "Prendario",
  REFACCIONARIO: "Refaccionario",
  HABILITACION_AVIO: "Habilitación / Avío",
  CUENTA_CORRIENTE: "Cuenta corriente (revolvente)",
  LINEA_REVOLVENTE: "Línea de crédito revolvente",
  ARRENDAMIENTO_FINANCIERO: "Arrendamiento financiero",
  FACTORAJE_FINANCIERO: "Factoraje financiero",
};

export const productoCredito = (cr) =>
  cr?.producto
  || cr?.producto_nombre
  || cr?.tipo_credito_label
  || ETIQUETA_INSTRUMENTO[cr?.tipo_credito]
  || "Sin producto registrado";

export default productoCredito;
